import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-hub-600 hover:text-hub-700 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
        
        <div className="bg-white rounded-xl shadow-sm p-8">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-8 h-8 text-hub-600" />
            <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
          </div>
          
          <p className="text-sm text-gray-500 mb-8">Last Updated: January 7, 2026</p>
          
          <div className="prose prose-gray max-w-none">
            <h2>1. Introduction</h2>
            <p>
              This Privacy Policy explains how Hubtractor collects, uses, and protects your information.
            </p>
            
            <h2>2. Information We Collect</h2>
            <p><strong>Account Information:</strong></p>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Mailing address</li>
            </ul>
            
            <p><strong>Usage Information:</strong></p>
            <ul>
              <li>Gig assignments and history</li>
              <li>Schedule data</li>
              <li>Payment records</li>
            </ul>
            
            <h2>3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Assign and manage gigs</li>
              <li>Send schedule notifications and reminders</li>
              <li>Process payments</li>
              <li>Communicate operational updates</li>
              <li>Improve our services</li>
            </ul>
            
            <h2>4. SMS/Text Messaging</h2>
            <p>
              <strong>What We Send:</strong> If you opt in to SMS notifications, we will send text 
              messages regarding gig assignments, schedule reminders, schedule changes, and payment 
              confirmations.
            </p>
            
            <p>
              <strong>Consent:</strong> By providing your phone number and checking the SMS consent 
              box, you expressly consent to receive text messages from Frequency Entertainment LLC 
              via the Hubtractor platform.
            </p>
            
            <p>
              <strong>Message Frequency:</strong> Varies based on gig activity, typically 2-10 
              messages per week for active contractors.
            </p>
            
            <p>
              <strong>Costs:</strong> Message and data rates may apply based on your carrier plan.
            </p>
            
            <p>
              <strong>Opt-Out:</strong> Reply STOP to any message to opt out. You can also disable 
              SMS in your profile settings.
            </p>
            
            <p>
              <strong>Help:</strong> Reply HELP for assistance or contact{' '}
              <a href="mailto:info@frequencyentertainment.net">info@frequencyentertainment.net</a>
            </p>
            
            <p>
              <strong>No Sharing of Mobile Information:</strong> We do not share mobile contact 
              information with third parties or affiliates for marketing or promotional purposes. 
              Information may be shared with subcontractors in support services, such as customer 
              service. All other categories exclude text messaging originator opt-in data and consent; 
              this information will not be shared with any third parties.
            </p>
            
            <h2>5. Data Sharing</h2>
            <p>
              We do not sell your personal information. Text messaging originator opt-in data and 
              consent will not be shared with any third parties under any circumstances. We may share 
              other information with:
            </p>
            <ul>
              <li>Payment processors (to facilitate payments)</li>
              <li>Service providers (who assist in platform operations)</li>
              <li>Legal authorities (if required by law)</li>
            </ul>
            
            <h2>6. Data Security</h2>
            <p>
              We implement reasonable security measures to protect your information. However, no 
              method of transmission over the Internet is 100% secure.
            </p>
            
            <h2>7. Your Rights</h2>
            <p>You may:</p>
            <ul>
              <li>Access your personal information via your profile</li>
              <li>Update or correct your information</li>
              <li>Request deletion of your account</li>
              <li>Opt out of SMS notifications</li>
            </ul>
            
            <h2>8. Data Retention</h2>
            <p>
              We retain your information for as long as your account is active or as needed to 
              provide services and comply with legal obligations.
            </p>
            
            <h2>9. Children's Privacy</h2>
            <p>
              Our Platform is not intended for individuals under 18 years of age.
            </p>
            
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of significant 
              changes via email or Platform notification.
            </p>
            
            <h2>11. Contact Us</h2>
            <p>For questions about this Privacy Policy:</p>
            <p>
              Frequency Entertainment LLC<br />
              Email: <a href="mailto:info@frequencyentertainment.net">info@frequencyentertainment.net</a><br />
              Phone: (702) 324-2583<br />
              Location: Las Vegas, NV
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
